import { padStart } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useTabsContext } from './Tabs.hooks';
// Custom hook.
// -----------------------------------------------------------------------------
export const useTabLabelNumber = ({ definition, number }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { setSelectedTabId } = useTabsContext();
    // Handlers.
    // ---------------------------------------------------------------------------
    const handleOnClick = useCallback(() => {
        setSelectedTabId(definition.id);
    }, [definition.id, setSelectedTabId]);
    // Variables.
    // ---------------------------------------------------------------------------
    const isDisabled = useMemo(() => definition.disabled || false, [definition.disabled]);
    const label = useMemo(() => padStart(number.toString(), 2, '0'), [number]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        isDisabled,
        label,
        onClick: handleOnClick
    };
};
//# sourceMappingURL=TabLabelNumber.hooks.js.map